export default __webpack_public_path__ + "static/media/7.6c76fd3d.png";